import {request} from "./axios";
//获取系统信息
export const getEqInitial=(param={}, options = {})=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/getEqInitial.ashx',
    data: param,
    silentRefresh: options.silentRefresh === true
  })
}

export const getCaptcha=(param={})=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/captcha.ashx',
    data: param,
    responseType: 'arraybuffer'
  })
}
//获取用户个人信息
export const getUserInfo=(param)=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/getUserInfo.ashx',
    data: param
  })
}
//获取后台管理设置信息
export const getSys=(param)=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/getsys.ashx',
    data: param
  })
}

//获取应用权限功能列表
export const getRolePermis=(param)=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/getRolePermis.ashx',
    data: param
  })
}

//获取所选门户权限功能列表
export const getMenuPermis=(param)=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/getMenuPermis.ashx',
    data: param
  })
}
//修改用户密码
export const setUserPassword=(param)=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/setUserPassword.ashx',
    data: param
  })
}
//通过手机号验证码修改用户密码
export const setUserPasswordBySms=(param)=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/setUserPasswordBySms.ashx',
    data: param
  })
}
//修改用户手机号
export const setUserPhone=(param)=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/setUserPhone.ashx',
    data: param
  })
}
//更新用户头像
export const setUserImg=(param)=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/setUserImg.ashx',
    data: param
  })
}

/** 账号安全状态（进入主框架调用；返回布尔状态位，不含密码） */
export const getAccountSecurity=(param={}, options = {})=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/getAccountSecurity.ashx',
    data: param,
    silentRefresh: options.silentRefresh === true
  })
}
//修改用户手机号
export const setUserWxBind=(param)=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/setUserWxBind.ashx',
    data: param
  })
}

//获取所选门户权限功能列表
export const setRolePermis=(param)=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/setRolePermis.ashx',
    data: param
  })
}
//写入后台主体设置信息
export const setSyszt=(param)=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/setsyszt.ashx',
    data: param
  })
}
//写入后台微信公众号信息设置
export const setWxsys=(param)=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/setWxsys.ashx',
    data: param
  })
}

//写入后台基础设置信息
export const setsysFrame=(param)=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/setsysframe.ashx',
    data: param
  })
}

/** 收钱吧终端激活（请求体由 axios 拦截器统一加密） */
export const sqbActivate = (param) => {
  return request({
    method: 'post',
    url: '/Q7FileAPI/E5API/sqbActivate.ashx',
    data: param
  })
}

/** 收钱吧已激活终端列表（可选传 deviceId / device_id 筛选单台；不传则当前 app 下全部） */
export const sqbActivatedList = (param) => {
  return request({
    method: 'post',
    url: '/Q7FileAPI/E5API/sqbActivatedList.ashx',
    silentRefresh: true,
    data: param
  })
}

/** 收钱吧 H5 支付：签到 + 预下单，返回收银台链接（PayView 点击支付时调用） */
export const sqbH5Pay = (param) => {
  return request({
    method: 'post',
    url: '/Q7FileAPI/E5API/sqbH5Pay.ashx',
    data: param
  })
}



//获取角色数据集列表
export const getRoleCode=(param)=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/getrolecode.ashx',
    data: param
  })
} 
//获取微信临时二维码
export const getTempQrCode=(param)=>{
  return request({
    method: 'post',
    url:'/WXmpApi/WxAPI/WxTempQrCode.ashx',
    data: param,
    silentRefresh: true,  // 添加无感刷新配置
    apitype: 'wxmp' // 添加apitype配置
  })
}
 
//Q7获取微信临时二维码
export const getQ7TempQrCode=(param)=>{
  return request({
    method: 'post',
    url:'/WXSendApi/WxAPI/WxTempQrCode.ashx',
    data: param,
    silentRefresh: true,  // 添加无感刷新配置
    apitype: 'wxsend'
  })
}
 
export const getUserList=(param)=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/CoreAPI/coregetuserlist.ashx',
    data: param
  })
}

// 获取流程执行记录
export const GetFlowLogs=(param)=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/getFlowLogs.ashx',
    silentRefresh: true,  // 添加无感刷新配置
    data: param , 
  })
}

//获取扫描状态
export const WxGetScanstate=(param)=>{
  return request({
    method: 'post',
    url:'/WXmpApi/WxAPI/WxGetScanstate.ashx',
    data: param,
    silentRefresh: true,  // 添加无感刷新配置
    apitype: 'wxmp' // 添加apitype配置
  })
}

//Q7获取扫描状态
export const WxGetQ7Scanstate=(param)=>{
  return request({
    method: 'post',
    url:'/WXSendApi/WxAPI/WxGetScanstate.ashx',
    data: param,
    silentRefresh: true,  // 添加无感刷新配置
    apitype: 'wxsend'
  })
}
//发送短信验证码
export const sendSmsApi=(param)=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/TXsmsCode.ashx',
    data: param , 
  })
}
//验证短信验证码（仅验证，不绑定手机号或修改密码）
export const verifySmsCode=(param)=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/verifySmsCode.ashx',
    data: param , 
  })
}
//获取模板字段
export const getMobLabe=(param)=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/getMobFromData.ashx',
    data: param , 
  })
}


//写入角色编码信息
export const setRoleCode=(param)=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/setrolecode.ashx',
    data: param
  })
}
//删除角色编码信息
export const delRoleCode=(param)=>{
  return request({
    method: 'post',
    url:'/Q7FileAPI/E5API/delrolecode.ashx',
    data: param
  })
}
